import html2canvas from 'html2canvas'

import './screenshot-control.styl'

class LayerControl {
  constructor(map) {
    this._container = null
    this.map = map
  }

  onAdd() {
    this._container = document.createElement('div')
    this._container.className = `maplibregl-ctrl maplibregl-ctrl-group maplibregl-ctrl-screenshot`

    const button = document.createElement('button')
    button.type = 'button'
    button.title = 'Take a screenshot'
    button.onclick = () => this.takeScreenshot()

    this._container.appendChild(button)

    return this._container
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container)
  }

  async takeScreenshot() {
    const mapContainer = this.map.getContainer()
    const controlsEl = mapContainer.querySelector('.maplibregl-control-container')

    controlsEl.style.display = 'none'

    html2canvas(mapContainer).then((canvas) => {
      canvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'screenshot.png'
        link.click()
        URL.revokeObjectURL(url)
      })
      controlsEl.style.display = ''
    })
  }
}

export default LayerControl
